module.exports = __webpack_public_path__ + "static/media/basiq.a8adc983.jpeg";